import logo from '../../../../../app/assets/images/job_search/default_logo.png'

export const getDefaultLogoForCompany = () => {
  return logo
}
